import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { ModalContext } from 'component/Modal/modalContext';
import { addItem } from './state/action';
import AddConfirmModal from 'container/BookStorePage/AddConfirmModal';
import ForeignLocationModal from 'container/BookStorePage/ForeignLocationModal';
import { Trans, useTranslation } from 'react-i18next';
import { toBeContinue } from 'common/util/util';
import AddPackageConfirmModal from "./AddPackageConfirmModal";

const Style = {
  Desc: styled.p`
    margin-top: 1em;
    font-size: 2em;
    font-weight: 700;
    &.subDesc {
      margin-bottom: 2em;
      color: #8b8f99;
      font-size: 1.6em;
      font-weight: 400;
    }
  `,
  ButtonContainer: styled.div`
    display: flex;
    > * {
      flex: 1;
    }
  `,
  Button: styled.button`
    display: inline-block;
    height: 6rem;
    border: 1px #8b8f99 solid;
    border-radius: 0.375em;
    font-size: 1.6em;
    font-weight: 500;
    letter-spacing: 0.1px;
    span {
      display: block;
    }
    &.primary {
      margin-right: 0.5em;
      border: 0;
      background-color: #475cc7;
      color: #fff;
    }
  `,
};

const PurchaseModal = ({ data, url }) => {
  const { t } = useTranslation('bookstorePage');
  let dispatch = useDispatch();
  const { handleModal } = React.useContext(ModalContext);

  const clickYes = () => {
    dispatch(addItem(data));
    handleModal(<AddPackageConfirmModal/>);
  };

  const clickGoAmazon = (e) => {
    if(data.globalBookUrl && data.globalBookUrl !== '') {
      window.open(data.globalBookUrl, '_blank');
      handleModal();
    } else {
      toBeContinue(e);
    }
  };
  // ✅ 자동 실행 (컴포넌트가 렌더링되면 즉시 실행)
  useEffect(() => {
    clickYes();
  }, []); // 의존성 없음 => 마운트 시 1회만 실행

  return null; // ✅ 버튼/내용 없이 자동 실행만 하고 아무것도 렌더링하지 않음

};

export default PurchaseModal;
